// 预支申请单选择
import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, nullDate, getListIds } from '../../public/utility'
class AdvanceApplicationSelectDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
        this.doGetSelectAdvance()
    }

    doGetSelectAdvance = (searchString = '') => {
        const { advanceExpenseID } = this.props
        Tyan.doPostEvent('GetSelectAdvance', {
            data: {
                advanceExpenseID,
                search: searchString
            },
            onEnd: ({ errorMessage, initValues预支申请单 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ initValues基本信息: {}, initValues预支申请单 })
                }
            }
        })
    }

    handlerSave = () => {
        const { advanceExpenseID, onClose, onSave } = this.props
        const { changedValues基本信息 } = this.state
        Tyan.doPostEvent('SaveSelectAdvance', {
            data: {
                advanceExpenseID, changedValues基本信息
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    onClose && onClose()
                    onSave && onSave()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        const { initValues预支申请单 } = this.state
        return [
            {
                _checkgrid: '', name: '预支申请单', rowNumbers: false, minRows: 15, margin: "5px 10px 5px 10px", minWidth: '90%',
                itemsValues: initValues预支申请单, onSearch: this.doGetSelectAdvance,
                columns: [
                    { _text: '预支申请单号', minWidth: 150, flex: 1 },
                    { _float: '预支金额', minWidth: 150, flex: 1 },
                    { _date: '申请日期', minWidth: 150, flex: 1 },
                    { _text: '申请人', minWidth: 150, flex: 1 },
                    { _text: '用途说明', minWidth: 150, flex: 1 },
                ],
            }]
    }

    render() {
        const { showMessage: Message, showBody: Body, bReadOnly, } = this.props
        const { errorMessage, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="1000"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerSave, disabled: !this.bChanged() },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(AdvanceApplicationSelectDiv)